import React, { useId } from "react";
import { Paperclip } from "lucide-react";

/* The one upload control: an outlined button plus the chosen file's name,
   in place of the browser's "Choose File / No file chosen". The real input
   is visually hidden but still focusable, so keyboard and screen reader
   users get the native picker. */
export default function FileButton({ onFile, file, label = "Attach a file", accept, className = "" }) {
  const id = useId();
  return (
    <span className={`inline-flex min-w-0 items-center gap-2 ${className}`}>
      <input
        id={id}
        type="file"
        accept={accept}
        aria-label={label}
        onChange={(e) => {
          onFile(e.target.files?.[0] || null);
          // Clear it so picking the same file again after a send still fires.
          e.target.value = "";
        }}
        className="peer sr-only"
      />
      <label
        htmlFor={id}
        className="inline-flex shrink-0 cursor-pointer items-center gap-1.5 rounded-pill border border-line-strong bg-surface px-3 py-2 text-sm font-medium text-ink hover:bg-sunken peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-brand"
      >
        <Paperclip className="h-4 w-4" /> {label}
      </label>
      {file && <span className="min-w-0 truncate text-sm text-secondary">{file.name}</span>}
    </span>
  );
}
